<template>
    <div id="subscribe-form">
        <h4 class="fw-normal mb-3">{{ $t('subscribe.title') }}</h4>
        <div class="form-group mb-3">
            <label class="control-label mb-1">{{ $t('subscribe.input_label') }}</label>
            <div class="input-group mb-3">
                <input type="text" class="form-control" :placeholder="$t('subscribe.input_placeholder')" v-model="email" ref="input">
                <button class="btn btn-primary text-white" type="button" @click="subscribe">
                    <font-awesome-icon :icon="['fas', 'paper-plane']" v-if="!loader" />
                    <span class="loader" v-else></span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import { useToast } from "vue-toastification"

const toast = useToast();

export default {
    name: 'SubscribeForm',
    data() {
        return {
            email: '',
            loader: false
        };
    },
    methods: {
        subscribe(){
            const self = this;
            if(self.email == ''){
                self.$refs.input.focus();
                return;
            }
            self.loader = true;
            setTimeout(function(){
                self.loader = false;
                self.email = '';
                toast.success('Вы успешно подписались на новости!');
            }, 1000)
        }
    },
}
</script>

<style scoped>
    @media (max-width: 768px) {
        #subscribe-form h4{
            font-size: 1.2rem !important;
            margin-top: 1rem !important;
            margin-bottom: 0.5rem !important;
        }
        #subscribe-form .input-group.mb-3, #subscribe-form .form-group.mb-3{
            margin-bottom: 0 !important;
        }
    }
    .loader {
        width: 14px;
        height: 14px;
        border: 2px solid var(--bs-white);
        border-bottom-color: transparent;
        border-radius: 50%;
        display: inline-block;
        box-sizing: border-box;
        animation: rotation 1s linear infinite;
    }
    @keyframes rotation {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    } 
</style>